import React from "react";
import HeaderThree from "../../../../components/header/HeaderThree";
import { Helmet } from "react-helmet";
import FooterTwo from "../../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../../components/footer/CopyRightTwo";
import CoreComponent2 from "../../../../assets/Sub-component/CoreComponent2";
import Banner from "../../../../assets/Sub-component/Banner";

import Collaboration from "../../../../assets/Services/About_us/Collaboration.svg";
import Expertise from "../../../../assets/Services/About_us/Expertise.svg";
import Innovation from "../../../../assets/Services/About_us/Innovation.svg";

import Mission from '../../../../assets/Services/Aboutus/missions.png'
import Vision from '../../../../assets/Services/Aboutus/visionss.png'
import launchingimage from '../../../../assets/Launchingimage.png'
const AboutCustomerSupport = () => {
  const banner = [
    {
      title: "Interested in learning about our work culture?",
      desc: "A group of skilled developers has been brought together to maximize the efficiency of your business, so prepare to release an application.",
      title2: "Interested in learning about our work culture?",
    },
  ];

  const data = [
    {
      icon: Expertise,
      title: "Expertise",
      desc: "Our years of practical experience range from blockchain logic to game mechanics. We Raiden, understand the work and tailor it to your specific requirements.",
    },
    {
      icon: Innovation,
      title: " Innovation",
      desc: " Innovation is Raiden’s core. Our ability to predict trends, embrace change, and transform ideas into ground-breaking, scalable solutions. ",
    },
    {
      icon: Collaboration,
      title: " Collaboration",
      desc: " Teamwork and trust are the foundations of great results. We thoroughly examine your objectives, pay close attention, and collaborate on each stage for a complete solution. ",
    },
  ];
  return (
    <> <img src={launchingimage} className="Bg-image"></img>
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container text-center d-flex justify-content-center align-items-center" style={{ minHeight: "73vh" }}>
        <div className=" row  ">
          <div className="">
            <h1 className="lh-1 h1-heading fs-lg-2 ">
              The Powerhouse behind Vision and Innovation{" "}
            </h1>
            <p className="mt-2 mb-0 text-center   h1-para">
              We create experiences that not only transform but also reinvent
              through the use of cutting-edge technology and relentless
              innovation.
            </p>
          </div>
        </div>
      </div>

      <div className="  mb-80 marb ">
        <div className=" p-4 ">
          <div className="row  align-items-center">
             <div
              className=" col-lg-6 m-auto text-center text-lg-right order-lg-last">
              <div className="screen-container">
               <img
                  src={Vision}
                  alt="shape"
                  className="ms-auto bg-round-shape rounded-circle w-75"
                />
                <div className="block-content">
                  <div className="row align-items-center"></div>
                </div>
              </div>
            </div>
             
            <div className="col-lg-6">
              <h2 className="lh-base mb-0   h2-heading  ">VISION</h2>
              <p
                className="h3-para lh-base mt-1 mb-0 text-lg-start"
               
              >
                At Raiden Labs, we actively shape the future of technology
                rather than merely following it. Our digital solutions combine
                blockchain, artificial intelligence, and virtual and augmented
                reality to blur the boundaries between the online and offline
                worlds. We are actively developing a hyperconnected, data-driven
                society, so it is not just a distant aspiration. Envision
                environments, data, and people all seamlessly interacting so
                that everything functions as a whole. And that's where we are
                going.
              </p>
              <p className="h3-para lh-base mt-3 text-lg-start">
                Our team is always working to improve our accuracy and
                creativity. We concentrate on creating dependable, scalable
                platforms that speed up immersive, real-time interaction. We
                start with a high bar and keep raising it. Ultimately, we
                revolutionize digital experiences by providing our clients with
                pioneering solutions that exceed the boundaries of what is
                possible.{" "}
              </p>
            </div>
           
          </div>
        </div>
      </div>

      <div className="  mb-80 marb ">
        <div className=" p-4 ">
          <div
            className="row  align-items-center   row-reverse "
            style={{ flexDirection: "row-reverse" }}
          >
            <div className=" col-lg-6 m-auto text-center text-lg-right order-lg-last">
              <div className="screen-container">
                <img
                  src={Mission}
                  alt="shape"
                  className="ms-auto bg-round-shape w-75" 
                />
                <div className="block-content">
                  <div className="row align-items-center"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <h2 className="lh-base h2-heading mb-0 ">MISSION</h2>
              <p
                className="h3-para lh-base mt-1 mb-0 text-lg-start"
               
              >
                Here at Raiden Labs, we expertly blend artistic vision with
                state-of-the-art technology. Our main objective is to create
                immersive worlds and inventive digital stories using blockchain,
                augmented and virtual reality, and artificial intelligence.
              </p>
              <p className="h3-para lh-base  text-lg-start mt-3 ">
                We aim to empower people and businesses by developing tools that
                revolutionize how people communicate, learn, and express
                themselves. Our goal is to create a future in which our
                technology and artistic creations can be effortlessly integrated
                into daily life, creating new avenues for communication,
                productivity, and human interaction.
              </p>
            </div>
          </div>
        </div>
      </div>

     
      <CoreComponent2 />
      <div className="container d-flex align-items-center flex-wrap mt-80 mart ">
        <div className="row d-flex  align-items-center justify-content-center">
          <div className="col-lg-6 col-11 mx-auto bg-black pt-40 pb-40 ps-4 pe-2 mb-4 mb-lg-0">
            <h2 className="h2-heading text-start fs-2 mb-3 lh-sm text-white">
             Why Raiden Labs ?
            </h2>
            <h3 className="h3-heading fs-4 mb-2 pb-1 text-white"> </h3>
            <p className="h3-para h1-para lh-base  text-white">
              {" "}
              Raiden Labs stand with friendly interface with lots of features
              that help our team and customer to collaborate easily.
            </p>
          </div>

          <div className="col-lg-6 col-11 mx-auto bg-light shadow py-4 ps-30 pe-30 d-flex align-items-center justify-content-center flex-column ">
            {data.map((item, j) => (
              <div className="row ps-3 pe-2 mb-4 " key={j}>
                <div className="d-flex align-items-center justify-content-start ">
                  <div
                    className="bg-white me-1 d-flex flex-column border  align-items-center justify-content-center  rounded-circle"
                    style={{ width: 35, height: 35 }}
                  >
                    <img className="m-0 w-75 " src={item.icon} alt="" />
                  </div>
                  <h3 className="h3-heading text-start fs-5 ms-2">
                    {item.title}
                  </h3>
                </div>
                <p className="h3-para fs-6 lh-sm pt-1">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      

      <div className="border-y-div m-0">
        <Banner banner={banner} />
      </div>

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default AboutCustomerSupport;
